"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ShadowyBox = _interopRequireDefault(require("../ShadowyBox"));

require("../assets/css/font-face.css");

require("./Tooltip.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Tooltip = function Tooltip(_ref) {
  var children = _ref.children,
      content = _ref.content,
      align = _ref.align;
  var wrapperClass = 'tooltip';
  if (align === 'right') wrapperClass += ' tooltip--right';
  if (align === 'bottom') wrapperClass += ' tooltip--bottom';
  if (align === 'left') wrapperClass += ' tooltip--left';
  return _react.default.createElement("div", {
    className: wrapperClass
  }, _react.default.createElement("div", {
    className: "tooltip__children"
  }, children), _react.default.createElement("div", {
    className: "tooltip__content"
  }, _react.default.createElement(_ShadowyBox.default, null, content)));
};

Tooltip.defaultProps = {
  align: '',
  content: ''
};
Tooltip.propTypes = {
  /** Componente em que o Tooltip irá aparecer */
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]).isRequired,

  /** Conteúdo do Tooltip */
  content: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]).isRequired,

  /** Alinhamento do Tooltip em relação ao componente filho */
  align: _propTypes.default.string
};
var _default = Tooltip;
exports.default = _default;